module.exports = {"id":"227796","name":"Christian Pulisic","rating":"79","photo":"./data/images/photos/4/227796.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["AD","AG","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianPulisic0.json
// module id = 800
// module chunks = 0